var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "event-reg-form"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('section', {
    staticClass: "col-md-8 pr-lg-6"
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.existingFile,
      expression: "existingFile"
    }],
    staticClass: "custom-control custom-radio custom-control-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.useFile,
      expression: "useFile"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "value": "0",
      "type": "radio",
      "id": "useExisting"
    },
    domProps: {
      "checked": _vm._q(_vm.useFile, "0")
    },
    on: {
      "change": function ($event) {
        _vm.useFile = "0";
      }
    }
  }), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "useExisting"
    }
  }, [_vm._v("Use existing file(s)")])]), _c('div', {
    staticClass: "custom-control custom-radio custom-control-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.useFile,
      expression: "useFile"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "value": "1",
      "type": "radio",
      "id": "uploadNew"
    },
    domProps: {
      "checked": _vm._q(_vm.useFile, "1")
    },
    on: {
      "change": function ($event) {
        _vm.useFile = "1";
      }
    }
  }), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "uploadNew"
    }
  }, [_vm._v("Upload a new file(s)")])])]), _vm.useFile === '0' ? _c('div', {
    staticClass: "text-center"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm mt-3"
  }, [_vm.nationalIdFront ? _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function ($event) {
        return _vm.downloadPrevFile('front');
      }
    }
  }, [_vm._v("Document front side")])]) : _vm._e(), _vm.nationalIdBack && _vm.idType !== 'passport' ? _c('li', {
    staticClass: "page-item"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function ($event) {
        return _vm.downloadPrevFile('back');
      }
    }
  }, [_vm._v("Document back side")])]) : _vm._e()]), _c('div', {
    staticClass: "text-left text-primary"
  }, [_vm._v("Document Expiry Date: " + _vm._s(_vm._f("dateFormat")(_vm.expiryDate)))])]) : _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "select-field form-group"
  }, [_c('label', {
    attrs: {
      "for": "idType"
    }
  }, [_vm._v("ID Type")]), _c('v-select', {
    staticClass: "style-chooser",
    attrs: {
      "label": "label",
      "options": [{
        label: 'National ID',
        value: 'nationalId'
      }, {
        label: 'Passport',
        value: 'passport'
      }],
      "reduce": function (e) {
        return e.value;
      },
      "clearable": false,
      "id": "idType"
    },
    model: {
      value: _vm.idType,
      callback: function ($$v) {
        _vm.idType = $$v;
      },
      expression: "idType"
    }
  }), _vm.getError('idType') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("ID Type is required")]) : _vm._e()], 1), _c('div', {
    staticClass: "custom-file form-group mt-0 mb-5"
  }, [_c('input', {
    staticClass: "custom-file-input",
    attrs: {
      "id": "national-id-front",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function ($event) {
        return _vm.handleFileUpload('nationalIdFront', $event);
      }
    }
  }), _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "national-id-front"
    }
  }, [_vm._v("Passport / National ID (front)")]), _c('div', {
    staticClass: "fileName"
  }, [_vm._v(_vm._s(_vm.getFileName('nationalIdFront')))]), _vm.getError('nationalIdFront') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("required")]) : _vm._e(), _c('small', {
    staticClass: "text-help-info"
  }, [_vm._v(" Please upload a clear copy of your National Id/passport with a valid expiry date ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.idType !== 'passport',
      expression: "idType !== 'passport'"
    }],
    staticClass: "custom-file form-group mt-0"
  }, [_c('input', {
    staticClass: "custom-file-input",
    attrs: {
      "id": "national-id-back",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function ($event) {
        return _vm.handleFileUpload('nationalIdBack', $event);
      }
    }
  }), _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "national-id-back"
    }
  }, [_vm._v("National ID (back)")]), _c('div', {
    staticClass: "fileName"
  }, [_vm._v(_vm._s(_vm.getFileName('nationalIdBack')))]), _vm.getError('nationalIdBack') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("required")]) : _vm._e(), _c('small', {
    staticClass: "text-help-info"
  }, [_vm._v("Please upload a clear copy of the back of your National ID")])]), _c('div', {
    staticClass: "input-field form-group mt-3"
  }, [_c('span', [_vm._v("National ID / Passport Expiry Date")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.expiryDate,
      expression: "expiryDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "dateExpiryId"
    },
    domProps: {
      "value": _vm.expiryDate
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.expiryDate = $event.target.value;
      }
    }
  }), _vm.getError('expiryDate') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" National ID / Passport Expiry Date is required ")]) : _vm._e()])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }